import { RDIrrigation } from '@cibo/core'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

import { useMemo } from 'react'

export const IrrigationPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/IrrigationPanelTable')
  const columns = useMemo(
    () => [
      {
        header: t('irrigation'),
        cellContents: (irrigationEvents?: RDIrrigation) => (
          <>
            {!!irrigationEvents?.result !== undefined
              ? irrigationEvents?.result
                ? t('irrigated')
                : t('notIrrigated')
              : '--'}
          </>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDIrrigation> traitId="irrigation" columns={columns} />
}
